import React from "react";
import tw from "twin.macro";
import { motion } from "framer-motion";
import useInView from "helpers/useInView";

const StyledDiv = tw.div`font-display min-h-screen text-secondary-500 p-8 overflow-hidden`;

function AnimationReveal({ disabled, children }) {
  if (disabled) {
    return <>{children}</>;
  }

  if (!Array.isArray(children)) children = [children];

  const childrenWithAnimation = children.map((child, i) => {
    return (
      <AnimatedFadeInComponent key={i}>
        {child}
      </AnimatedFadeInComponent>
    );
  });

  return <>{childrenWithAnimation}</>;
}

function AnimatedFadeInComponent({ children }) {
  const [ref, inView] = useInView({ margin: '-50px 0px 0px 0px' });

  return (
    <div ref={ref}>
      <motion.section
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{
          opacity: inView ? 1 : 0,
          scale: inView ? 1 : 0.9,
          transition: { duration: 0.8 }
        }}
      >
        {children}
      </motion.section>
    </div>
  );
}

export default props => (
  <StyledDiv className="App">
    <AnimationReveal {...props} />
  </StyledDiv>
);
